import { Configuration } from '@Types';
import { ResampleVerificationFields } from '@Types/sensorResample';

const RESAMPLE_REQUIRED_FIELDS = new Set([
	...Object.values(ResampleVerificationFields),
]);

const setDefaultValues = (configuration: Configuration): Configuration => {
	const clone = Object.assign({}, configuration);
	if (!configuration.dataSourceType) clone.dataSourceType = 'ODBC';
	if (!configuration.tankType) clone.tankType = 'cylindrical';
	return clone;
};

export const findResampleFieldsThatChanged = (
	current: Record<string, string>,
	configuration: Configuration,
) => {
	const conf = setDefaultValues(configuration);
	const fields: string[] = [];
	for (const e of Object.entries(current)) {
		const [formKey, formValue] = e;

		if (
			!RESAMPLE_REQUIRED_FIELDS.has(formKey as ResampleVerificationFields)
		)
			continue;

		if ((conf as never)[formKey] != formValue) fields.push(formKey); // ? different value
	}
	return fields;
};
